import axios from 'axios';

import { PRODUCT_API_URL, RESERVATION_V2_API_PREFIX } from '@src/constants/apis';

const productApiNetworkService = axios.create({
  baseURL: PRODUCT_API_URL,
});

// TODO remove after migration
export const productApiNetworkServiceFactory = (prefix: string) =>
  axios.create({
    baseURL: `${PRODUCT_API_URL}/${prefix}`,
  });

export const productApiV2NetworkService = productApiNetworkServiceFactory(RESERVATION_V2_API_PREFIX);

export default productApiNetworkService;
